$(document).ready(function() {
    var $tableComponent = $('.table__component');

    if(!($tableComponent.length > 0)) return;

    var $table = $tableComponent.find('table');
    var $tableContainer = $tableComponent.find('.table__container');

    var $tableVanish = $tableComponent.find('.table__vanish');

    var widthDiff = widthDiffTableFromContainer($table, $tableContainer);

    showHideVanishEffect($tableContainer, $tableVanish);

    $tableContainer.scroll(function(event) {
        showHideVanishEffect($(event.target), $tableVanish);
    })

    function widthDiffTableFromContainer($table, $tableContainer) {
        return $table.outerWidth() - $tableComponent.width();
    }

    function showHideVanishEffect($tableContainer, $tableVanish) {
        var table = $tableContainer.find('table');

        var widthDiff = widthDiffTableFromContainer($table, $tableContainer);

        console.log(widthDiff);

        if($tableContainer.scrollLeft() >= widthDiff){
            $tableVanish.hide();
        }
        else {
            $tableVanish.height($table.outerHeight());
            $tableVanish.show();
        }
    }

});